import { render, staticRenderFns } from "./PptSlides.vue?vue&type=template&id=652cc9f1&scoped=true&"
import script from "./PptSlides.vue?vue&type=script&lang=js&"
export * from "./PptSlides.vue?vue&type=script&lang=js&"
import style0 from "./PptSlides.vue?vue&type=style&index=0&id=652cc9f1&prod&lang=less&scoped=true&"
import style1 from "./PptSlides.vue?vue&type=style&index=1&id=652cc9f1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652cc9f1",
  null
  
)

export default component.exports